import React from 'react'
import moment from 'moment'

import {Container, Grid, Image} from 'semantic-ui-react'

const logo = require('/app/static/img/coc-logo.svg');

const Footer = () => (
    <Container style={{marginTop: '4em'}} textAlign={"center"}>
        <Image size='tiny' src={logo} centered/>
        <span>POJEX - a service by City of Code GmbH<br/>
            Adnet 436, 5421 Adnet, Austria<br/>
        </span>
        <p>© {moment().format('YYYY')} &sdot; <a href="https://www.cityofcode.io/"> cityofcode.io</a></p>

    </Container>
)

export default Footer
